<template>
  <div class="pc-competition-video">
    <h2>竞赛人员管理</h2>
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="edit()" class="edit-btn"
      >完成</El-button
    >

    <ul class="pc-competition-video-list">
      <li
        class="video-item"
        v-for="(item, index) in competitionPersonList"
        :key="index"
      >
        <div class="checkBox">
          <div class="checkBox1">
            <div>
              <span> 人员名称: </span>
              <el-input
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.field_name"
                placeholder="请输入人员名称"
              >
              </el-input>
            </div>
            <div></div>
            <div>
              <div class="countBox">
                <span> 最小人员数目:</span>
                <!-- v-show="isEditting == true" -->
                <el-input-number
                  class="countBox1"
                  :disabled="!isEditting || !item.isEdittingPerson"
                  v-model="item.min_count"
                  :step-strictly="true"
                  :min="0"
                  :max="100"
                  label=""
                ></el-input-number>
              </div>
              <div class="countBox">
                <span> 最大人员数目: </span>
                <!-- v-show="isEditting == true" -->
                <el-input-number
                  class="countBox2"
                  :disabled="!isEditting || !item.isEdittingPerson"
                  v-model="item.max_count"
                  :step-strictly="true"
                  :min="item.min_count"
                  :max="100"
                  label=""
                ></el-input-number>
              </div>
            </div>
            <div></div>
            <div>
              <span>城市:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.city"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
                        <div>
              <span>大学:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.university"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>学院:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.college"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>公司:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.company"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>邮箱:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.email"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>身份证:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.id_card"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>姓名:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.name"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>姓名拼音:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.name_pinyin"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>手机:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.phone"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>照片:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.photo"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
            <div>
              <span>学生证:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.student_id"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>

            <div>
              <span>用户名:</span>
              <el-radio-group
                :disabled="!isEditting || !item.isEdittingPerson"
                v-model="item.username"
              >
                <el-radio :label="0" :value="0">不需要</el-radio>
                <el-radio :label="2" :value="2">需要</el-radio>
                <el-radio :label="1" :value="1">必填</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="update" @click="editPerson(index, item)">
          <p v-if="!item.isEdittingPerson && isEditting">修改</p>
          <p
            v-if="item.isEdittingPerson && isEditting"
            @click="deleteShow(index)"
          >
            删除
          </p>
          <p
            v-if="item.isEdittingPerson && isEditting"
            @click="changePerson(item)"
          >
            确认
          </p>
        </div>
      </li>
    </ul>
    <div @click="addPerson()" class="add-btn" v-show="isEditting">
      <span>添加</span>
    </div>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";

import {
  competitionPerson_Api,
  createCompetitionPerson_Api,
  updateCompetitionPerson_Api,
  deleteCompetitionPerson_Api,
} from "../../../../apis/competition.api";

export default {
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      competitionPersonList: [],
      competition_id: null,
      delete_index: null,
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.getCompetitionPerson();
    }
  },
  components: {
    DeleteDialog,
  },
  methods: {
    edit() {
      this.isEditting = !this.isEditting;
      if (!this.isEditting) {
        this.competitionPersonList.forEach((item) => {
          item.isEdittingPerson = false;
        });
      }
    },
    addPerson() {
      this.competitionPersonList.push({
        method: "add",
        isEdittingPerson: true,
        city: 0,
        college: 0,
        company: 0,
        email: 0,
        field_name: "",
        id_card: 0,
        max_count: 0,
        min_count: 0,
        name: 0,
        name_pinyin: 0,
        phone: 0,
        photo: 0,
        student_id: 0,
        university: 0,
        username: 0,
      });
    },
    editPerson(index, item) {
      item.isEdittingPerson = true;
      this.$set(this.competitionPersonList, index, item);
    },
    getCompetitionPerson() {
      competitionPerson_Api(this.$route.query.id).then((res) => {
        this.competitionPersonList = res.data;
        this.competitionPersonList.forEach((item) => {
          item.method = "update";
          item.isEdittingPerson = false;
        });
        console.log(this.competitionPersonList);
      });
    },
    deleteConfirm() {
      console.log(this.competitionPersonList[this.delete_index]);
      let person_id = this.competitionPersonList[this.delete_index].id;
      if (person_id) {
        deleteCompetitionPerson_Api({ person_id: person_id })
          .then((res) => {
            this.$global.success(this, "删除成功");
            this.getCompetitionPerson();
            this.deleteDialogVisible = false;
          })
          .catch(() => {
            this.$global.error(this, "删除失败, 请重试");
          });
      } else {
        this.competitionPersonList.splice(this.delete_index, 1);
        this.deleteDialogVisible = false;
      }
    },
    closeDelete() {
      console.log(1324132);
      this.deleteDialogVisible = false;
    },
    deleteShow(index) {
      this.delete_index = index;
      this.deleteDialogVisible = true;
    },
    changePerson(item) {
      console.log(item);
      if (item.id) {
        item.person_id = item.id;
      }
      if (item.method == "update") {
        item.competition_id = this.$route.query.id;
        updateCompetitionPerson_Api(item)
          .then((res) => {
            this.getCompetitionPerson();
            console.log(res);
            this.$global.success(this, "更新成功");
          })
          .catch(() => {
            this.$global.error(this, "更新失败");
          });
      } else {
        item.competition_id = this.$route.query.id;
        createCompetitionPerson_Api(item)
          .then((res) => {
            this.getCompetitionPerson();
            this.$global.success(this, "添加成功");
          })
          .catch(() => {
            this.$global.error(this, "添加失败");
          });
      }

      console.log(item);
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-competition-video {
  @include box-model;
  .edit-btn {
    right: 30px;
  }
  .pc-competition-video-list {
    width: 100%;
    .video-item {
      display: flex;
      position: relative;
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px $timeBtn dashed;
      .update {
        display: flex;
        height: 30px;
        position: absolute;
        right: 20px;
        bottom: 20px;
        cursor: pointer;
        p {
          border: 1px $timeBtn dashed;
          text-align: center;
          width: 60px;
          height: 20px;
          color: $timeBtn;
          margin-left: 10px;
        }
        p:hover {
          background: $timeBtn;
          color: $base-color;
        }
      }
      .checkBox {
        display: flex;
        width: 100%;

        .checkBox1 {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          div {
            width: 40%;
            display: flex;
            margin-bottom: 10px;
            .countBox {
              display: flex;
              margin-right: 280px;
              .countBox1 {
                min-width: 200px;
              }
              .countBox2 {
                min-width: 200px;
              }
            }
          }
          span {
            display: block;
            min-width: 150px;
            height: 30px;
          }
        }
      }
      .video-item-left {
        position: relative;
        width: 400px !important;
        height: 160px;
        border: 1px solid #979797;
        margin-right: 20px;
        video {
          width: 285px;
          height: 160px;
        }
        img {
          width: 285px;
          height: 160px;
        }
      }

      .video-item-bottom {
        font-size: 14px;
        width: 80%;
        min-width: 700px;
        color: #434343;
        line-height: 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #434343;
          line-height: 21px;
        }
        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        /deep/
          .el-checkbox__input.is-disabled.is-checked
          .el-checkbox__inner::after {
          border-color: #fff;
        }
        /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #000;
        }
        /deep/ .el-input__inner {
          width: 90%;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
        /deep/ .el-input:first-of-type {
          margin-top: 0px;
        }
        /deep/ .el-input {
          margin-bottom: 10px;
        }
        textarea {
          width: 90%;
          height: 60px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          padding-left: 15px;
          outline-color: #dcdfe6;
          resize: none;
        }
        /deep/ input:-ms-input-placeholder,
        /deep/ textarea:-ms-input-placeholder {
          color: #999999;
        }
        /deep/ input::-webkit-input-placeholder,
        /deep/ textarea::-webkit-input-placeholder {
          color: #999999;
        }
        p {
          margin-top: 10px;
          width: 1200px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 21px;
        }
        .pc-video-content-bottom-subtitle {
          display: flex;
          span {
            display: inline-block;
            width: 100px;
            height: 26px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dcdfe6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 30px;
            // text-align: center;
            strong {
              // width: 48px;
              margin-left: 11px;
              font-size: 12px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5470c6;
              line-height: 12px;
              text-align: left;
            }
            i {
              display: inline-block;
              margin-top: -1px;
              // margin-right: -16px;
              // margin-left: 11px;
              width: 19px;
              height: 26px;
              background: #dcdfe6;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              color: #5470c6;
              text-align: right;
            }

            /deep/ .icon-zhuanhuan:before {
              font-size: 10px;
            }
            /deep/ .icon-shangchuanicon:before {
              font-size: 10px;
            }
          }
          /deep/ .el-upload--text {
            width: 100px;
            display: flex;
            justify-content: space-between;
            i {
              margin-top: 0;
              border-radius: 0 4px 4px 0 !important;
              display: inline-block;
              text-align: center;
            }
          }
          /deep/ .el-button--mini {
            // border-radius: 4px 0 0 4px !important;
            border: none;
            margin-left: 11px;
            margin-top: 1px;

            height: 24px;
            padding: 0;
            text-align: center;
            line-height: 26px;
          }
          /deep/ .el-button--primary {
            background-color: #fff;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #646464;
            font-size: 12px;
          }
        }
      }
      .video-item-position {
        width: 40px;
        height: 100px;
        text-align: center;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 20px;
        display: none;
        p {
          margin-bottom: 10px;
        }
        .pc-video-position-top {
          margin-top: 15px;
          // margin-bottom: 21px;
        }
      }
    }
  }
  .add-btn {
    width: 110px;
    height: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border: 1px #5470c6 dashed;
    span {
      font-size: 14px;
      text-align: center;
      color: #5470c6;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionPerson.vue